import React from "react";
import { useDispatch } from "react-redux";
import "../../../assets/styles/containers/_commentButtonGroup.scss";
import { duplicateComment, getCommentById, getCommentByIdNHT } from "../../store/action/CommentLibraryAction";
import { apiCall } from "../../utils/action";
import { libraryRatingId } from "../../common/TemplateUtils/lineRatingUtils";
import axios from "axios";
import config_settings from "../../config/config";

const ButtonGroup = (props) => {
  const dispatch = useDispatch();
  const { setState, row, state, GetCommentList, setNewlyAddedRows, isHTCompany, setDeleteConfirm, setdeleteROWID } = props;

  let BASE_URL;
  const origin = () => {
    let origin = window.location.origin.toLowerCase();
    if (origin.includes("https://")) origin = origin.replace("https://", "");
    else origin = origin.replace("http://", "");
    BASE_URL = config_settings[origin]?.SERVER_URL;
  };
  origin();

  const handleEdit = async () => {
    if (!isHTCompany) {
      const response = await dispatch(getCommentByIdNHT(row.id));
      const initialTags = Array.isArray(response?.tags) ? response.tags : [];
      const initialRatings = Array.isArray(response?.ratings) ? response.ratings : [];
      const locationArray = (response?.location || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .map((name) => ({ id: name, name }));
      const mappedTags = initialTags
        .map((t) => ({
          id: t?.pivot?.tag_id ?? t?.tag_id ?? t?.id ?? t?.tag?.id,
          name: t?.name ?? t?.tag?.name ?? t?.title,
          color: t?.color ?? t?.tag?.color,
        }))
        .filter((t) => t?.id);
      const mappedRatings = initialRatings
        .map((r) => ({
          // A join row's own `id` is not the rating id, so libraryRatingId only reads `id` on a bare rating.
          id: libraryRatingId(r),
          name: r?.Name ?? r?.rating?.Name ?? r?.title,
        }))
        .filter((r) => r?.id);
      setState((prev) => ({
        ...prev,
        openAddDialog: true,
        isEdit: true,
        comment_id: response?.id,
        commentTitle: response?.title || "",
        commentText: { innerHTML: response?.comment || "", dropdownList: response?.comment_dropdowns || [] },
        commentDropdownList: response?.comment_dropdowns || [],
        commentTag: mappedTags,
        commentRating: mappedRatings,
        location: locationArray,
      }));
      return;
    }
    setState((prevState) => ({ ...prevState, showLoader: true }));
    const response = await dispatch(getCommentById(row.id));
    const { tags, title, comment_text, id, summaries, summary_comment_text, comment_dropdowns, summary_comment_dropdowns } = response;
    if (response) {
      setState((prevState) => ({
        ...prevState,
        openAddDialog: true,
        isEdit: true,
        commentTag: tags?.filter((item) => item !== "")?.map((tag) => tag.tag) || [],
        commentTitle: title || "",
        commentText: { innerHTML: comment_text, dropdownList: comment_dropdowns },
        selectedComment: response,
        commentSummary: { innerHTML: summary_comment_text, dropdownList: summary_comment_dropdowns },
        commentSummaryTag: summaries?.filter((item) => item !== "")?.map((summary) => summary.summary),
        comment_id: id,
        showLoader: false,
        commentDropdownList: comment_dropdowns,
        summaryDropdownList: summary_comment_dropdowns,
      }));
    }
  };

  const handleDuplicate = async () => {
    if (!isHTCompany) return;
    setNewlyAddedRows({});
    const data = await dispatch(duplicateComment(row));
    if (data) {
      setNewlyAddedRows((prev) => ({ ...prev, [data.id]: true }));
      // Re-fetch with current filters so the list and pagination count stay accurate.
      setState((prevState) => ({ ...prevState, refreshTs: Date.now() }));
      setTimeout(() => {
        setNewlyAddedRows({});
      }, 1000);
    }
  };

  const handleDelete = () => {
    if (!isHTCompany) return;
    setState((prevState) => ({ ...prevState, openDeleteDialog: true, comment_id: row.id }));
  };


  const handleRestoreComment = () => {
    if (!isHTCompany) return;
    const formdata = { comment_id: row.id };
    apiCall(
      (response) => {
        if (response?.data) {
          setState((prevState) => ({
            ...prevState,
            filterType: "deleted",
            page: 0,
          }));
          GetCommentList({ filterByType: "deleted", filterByTagId: [] });
        }
      },
      formdata,
      "RESTORE_COMMENT",
      (error) => console.error("Error restoring comment:", error)
    );
  };

  return state?.filterType === "deleted" ? isHTCompany ? <div className="restore_button_container" onClick={() => handleRestoreComment()}>
    <div className="delete_button_group_tab">
      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.74992 12.833H2.83325V11.1663H8.74992C9.62492 11.1663 10.3852 10.8886 11.0308 10.333C11.6769 9.77745 11.9999 9.08301 11.9999 8.24967C11.9999 7.41634 11.6769 6.7219 11.0308 6.16634C10.3852 5.61079 9.62492 5.33301 8.74992 5.33301H3.49992L5.66658 7.49967L4.49992 8.66634L0.333252 4.49967L4.49992 0.333008L5.66658 1.49967L3.49992 3.66634H8.74992C10.0971 3.66634 11.2535 4.10384 12.2191 4.97884C13.1841 5.85384 13.6666 6.94412 13.6666 8.24967C13.6666 9.55523 13.1841 10.6455 12.2191 11.5205C11.2535 12.3955 10.0971 12.833 8.74992 12.833Z"
          fill="#454545"
        />
      </svg>
    </div>
    <span className="restore-text">Restore</span>
  </div > : null : (
    <>
      {" "}
      <div className="button_group_container">
        <div className="edit_button_group" onClick={() => handleEdit()}>
          <svg width="15.23" height="15.21" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 17H3.4L12.025 8.375L10.625 6.975L2 15.6V17ZM16.3 6.925L12.05 2.725L13.45 1.325C13.8333 0.941667 14.3043 0.75 14.863 0.75C15.421 0.75 15.8917 0.941667 16.275 1.325L17.675 2.725C18.0583 3.10833 18.2583 3.571 18.275 4.113C18.2917 4.65433 18.1083 5.11667 17.725 5.5L16.3 6.925ZM14.85 8.4L4.25 19H0V14.75L10.6 4.15L14.85 8.4Z"
              fill="#454545"
            />
          </svg>
        </div>
        {isHTCompany ? (
          <div className="duplicate_button_group" onClick={() => handleDuplicate()}>
            <svg width="15.33" height="18.33" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17 18H6C5.45 18 4.97917 17.8042 4.5875 17.4125C4.19583 17.0208 4 16.55 4 16V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H13L19 6V16C19 16.55 18.8042 17.0208 18.4125 17.4125C18.0208 17.8042 17.55 18 17 18ZM12 7V2H6V16H17V7H12ZM2 22C1.45 22 0.979167 21.8042 0.5875 21.4125C0.195833 21.0208 0 20.55 0 20V6H2V20H13V22H2Z" fill="#454545" />
            </svg>
          </div>
        ) : null}
        {isHTCompany ? <div className="delete_button_group" onClick={() => handleDelete()}>
          <svg width="14" height="15" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 18C2.45 18 1.97933 17.8043 1.588 17.4125C1.196 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.0208 14.4125 17.4125C14.0208 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
              fill="#D63D3D"
            />
          </svg>
        </div> : <div className="delete_button_group" onClick={() => { setDeleteConfirm(true); setdeleteROWID({ id: row?.id, name: row?.title }) }}>
          <svg width="14" height="15" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3 18C2.45 18 1.97933 17.8043 1.588 17.4125C1.196 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8043 17.0208 14.4125 17.4125C14.0208 17.8043 13.55 18 13 18H3ZM13 3H3V16H13V3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z"
              fill="#D63D3D"
            />
          </svg>
        </div>}
      </div >
    </>
  );
};

export default ButtonGroup;
